import React, {useEffect, useState} from "react";
import Page from "../../../layout/Page";
import {useNavigate, useParams} from "react-router-dom";
import leagueService from "../../../service/LeagueService";
import Container from "@mui/material/Container";
import {useTranslation} from "react-i18next";
import PageActions from "../../../components/PageActions";
import {useForm} from "react-hook-form";
import {MessageType} from "../../../util/Enums";
import useMessage from "../../../util/useMessage";
import BackButton from "../../../ui/BackButton";
import SaveButton from "../../../ui/SaveButton";
import Panel from "../../../ui/Panel";
import Input from "../../../ui/Input";
import ImagePickerButton from "../../../ui/ImagePickerButton";

const LeagueEditPage = ({title}) => {

    const param = useParams();
    const leagueId = param?.id;

    const {t} = useTranslation();
    const navigate = useNavigate();
    const showMessage = useMessage();

    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);

    const [league, setLeague] = useState(null);
    const [image, setImage] = useState(null);

    const {handleSubmit, register, formState: {errors}} = useForm();

    useEffect(() => {
        if (leagueId) {
            (async () => {
                setPageLoading(true);
                try {
                    const [_result] = await Promise.all([
                        leagueService.get(leagueId),
                    ]);
                    initPageValues(_result);
                } catch (e) {
                    console.error(e);
                }
                setPageLoading(false);
            })();
        } else {
            setPageLoading(false);
        }
        return () => {
        }
    }, [leagueId]);

    const initPageValues = (_league) => {
        setLeague(_league);
        setImage(_league?.image);
    }

    const onSubmit = async (data) => {

        if (loading) return false;
        try {
            setLoading(true);

            const obj = {
                id: leagueId | null,
                ...data,
                image,
            }
            const resultObject = await leagueService.saveOrUpdate(leagueId, obj);
            showMessage(t(leagueId ? 'message.updated' : 'message.created'));

            if (!leagueId) {
                navigate(`/commons/leagues/edit/${resultObject._id}`, {replace: true});
            } else {
                initPageValues(resultObject);
            }

        } catch ({code, message}) {
            showMessage(`${code} - ${message}`, MessageType.ERROR);
        } finally {
            setLoading(false);
        }
    }


    const ActionPanel = () => (
        <PageActions>
            <BackButton loading={loading}/>
            <SaveButton loading={loading}/>
        </PageActions>
    );


    return (
        <Page title={title} loading={pageLoading}>
            <Container maxWidth={"sm"}>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <ActionPanel/>

                    <Panel title={t('title.league')}>
                        <Input
                            defaultValue={league?.name}
                            label={t('label.name')}
                            error={errors?.name}
                            {...register("name", {
                                required: t('validation.required')
                            })}
                        />
                        <Input
                            defaultValue={league?.countryCode}
                            label={t('label.countryCode')}
                            error={errors?.countryCode}
                            {...register("countryCode", {
                                required: t('validation.required')
                            })}
                        />

                        <ImagePickerButton {...{image, setImage}} />
                    </Panel>
                    <ActionPanel/>
                </form>

            </Container>
        </Page>
    );

}

export default LeagueEditPage;
